//import api from '../api';
import { newAPIPost } from '../api/index.js'; 

export default {
  state: {
    loads: [],
    searchRequest: {},
  },
  mutations: {
    updateLoads(state, loads) {
      state.loads = loads;
    },
    updateSearchLoadRequest(state, searchRequest) {
      state.searchRequest = searchRequest;
    },
  },
  actions: {
    async loadLoads({ commit, state, getters }, request) {
      const fallbackRequest = request || state.searchRequest;
      const requestToSend = JSON.parse(JSON.stringify(fallbackRequest));

      if (requestToSend.loadIdFrom && !requestToSend.loadIdTo) {
        requestToSend.loadIdTo = requestToSend.loadIdFrom;
      }
      if (requestToSend.driverIdFrom && !requestToSend.driverIdTo) {
        requestToSend.driverIdTo = requestToSend.driverIdFrom;
      }
      if (requestToSend.haulerIdFrom && !requestToSend.haulerIdTo) {
        requestToSend.haulerIdTo = requestToSend.haulerIdFrom;
      }
      if (requestToSend.etaEnd) {
        requestToSend.etaEnd = moment(requestToSend.etaEnd)
          .endOf('d')
          .toDate();
      }
      if (requestToSend.deliveryEnd) {
        requestToSend.deliveryEnd = moment(requestToSend.deliveryEnd)
          .endOf('d')
          .toDate();
      }

      if (requestToSend.etaStart && !requestToSend.etaEnd) {
        requestToSend.etaEnd = moment(requestToSend.etaStart).endOf('d').toDate();
      }
      if (requestToSend.deliveryStart && !requestToSend.deliveryEnd) {
        requestToSend.deliveryEnd = moment(requestToSend.deliveryStart).endOf('d').toDate();
      }

      requestToSend.driverGroups = getters.flatWithChildDriverGroups(requestToSend.driverGroups);

      //const result = await api.post('/api/w/loads', requestToSend);
      const result = await newAPIPost('/api/w/loads', requestToSend);
      commit('updateSearchLoadRequest', fallbackRequest);
      return commit('updateLoads', result);
    },
    saveLoads(store, request) {
      //return api.post('/api/w/loads/save', request);
      return newAPIPost('/api/w/loads/save', request);
    },
  },
  getters: {
    getLoads: state => state.loads,
  },
};
